module.exports = __webpack_public_path__ + "img/shubhangi.7f7d56df.webp";